import styled from "@emotion/styled"
import {
	colorCanvas,
	colorContrastLow,
	colorContrastMedium,
	colorPrimary,
	fontPorscheNext,
} from "@porsche-design-system/components-react/emotion"

// copied and adjusted from node_modules/flatpickr/dist/themes/airbnb.css
export const FlatpickrWrapper = styled.div`
	font-family: ${fontPorscheNext};

	.flatpickr-calendar {
		background: transparent;
		opacity: 0;
		display: none;
		text-align: center;
		visibility: hidden;
		padding: 0;
		animation: none;
		direction: ltr;
		border: 1px solid ${colorContrastMedium};
		font-size: 14px;
		line-height: 24px;
		border-radius: 0;
		position: absolute;
		width: 307.875px;
		box-sizing: border-box;
		touch-action: manipulation;
		background: ${colorCanvas};
		box-shadow: 1px 0 0 #eee, -1px 0 0 #eee, 0 1px 0 #eee, 0 -1px 0 #eee, 0 3px 13px rgba(0, 0, 0, 0.08);

		&:before,
		&:after {
			display: none;
		}
	}
	
	.flatpickr-mobile {
		position: absolute;
		height: 0;
		width: 0;
		transform: translateY(-100%);
		opacity: 0;
	}

	.flatpickr-calendar.open,
	.flatpickr-calendar.inline {
		opacity: 1;
		max-height: 640px;
		visibility: visible;
	}

	.flatpickr-calendar.open {
		display: inline-block;
		z-index: 99999;
	}

	.flatpickr-calendar.animate.open {
		animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
	}

	.flatpickr-calendar.inline {
		display: block;
		position: relative;
		top: 2px;
	}

	/* rendered on the #top-layer as a popover, positioned by topLayerCalendar.ts, so reset the user agent styles */
	.flatpickr-calendar.static {
		position: fixed;
		inset: auto;
		margin: 0;
		overflow: visible;
		color: inherit;
	}

	.flatpickr-calendar.static.open {
		z-index: 999;
		display: block;
	}

	.flatpickr-calendar.multiMonth
	.flatpickr-days
	.dayContainer:nth-of-type(n + 1)
	.flatpickr-day.inRange:nth-of-type(7n + 7) {
		box-shadow: none !important;
	}

	.flatpickr-calendar.multiMonth
	.flatpickr-days
	.dayContainer:nth-of-type(n + 2)
	.flatpickr-day.inRange:nth-of-type(7n + 1) {
		box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
	}

	.flatpickr-calendar .hasWeeks .dayContainer,
	.flatpickr-calendar .hasTime .dayContainer {
		border-bottom: 0;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
	}

	.flatpickr-calendar .hasWeeks .dayContainer {
		border-left: 0;
	}

	.flatpickr-calendar.hasTime .flatpickr-time {
		height: 40px;
		border-top: 1px solid #eee;
	}

	.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
		height: auto;
	}

	.flatpickr-calendar.rightMost:before,
	.flatpickr-calendar.arrowRight:before,
	.flatpickr-calendar.rightMost:after,
	.flatpickr-calendar.arrowRight:after {
		left: auto;
		right: 22px;
	}

	.flatpickr-calendar.arrowCenter:before,
	.flatpickr-calendar.arrowCenter:after {
		left: 50%;
		right: 50%;
	}

	.flatpickr-calendar.arrowTop:before,
	.flatpickr-calendar.arrowTop:after {
		bottom: 100%;
	}

	.flatpickr-calendar.arrowTop:before {
		border-bottom-color: #eee;
	}

	.flatpickr-calendar.arrowTop:after {
		border-bottom-color: ${colorCanvas};
	}

	.flatpickr-calendar.arrowBottom:before,
	.flatpickr-calendar.arrowBottom:after {
		top: 100%;
	}

	.flatpickr-calendar.arrowBottom:before {
		border-top-color: #eee;
	}

	.flatpickr-calendar.arrowBottom:after {
		border-top-color: ${colorCanvas};
	}

	.flatpickr-calendar:focus {
		outline: 0;
	}

	.flatpickr-wrapper {
		width: 100%;
		position: relative;
		display: inline-block;
	}

	.flatpickr-months {
		display: flex;
		margin: 20px 0;
		position: relative;

		select::-ms-expand {
			display: none;
		}
	}

	.flatpickr-months .flatpickr-month {
		background: transparent;
		color: #3c3f40;
		fill: #3c3f40;
		height: 30px;
		line-height: 1;
		text-align: center;
		position: relative;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		overflow: hidden;
		flex: 1;
	}

	.flatpickr-months .flatpickr-prev-month,
	.flatpickr-months .flatpickr-next-month {
		text-decoration: none;
		cursor: pointer;
		position: absolute;
		top: 0;
		padding: 8px;
		z-index: 3;
		color: #3c3f40;
		fill: #3c3f40;
		display: flex;
		align-items: center;
	}

	.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
	.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
		display: none;
	}

	.flatpickr-months .flatpickr-prev-month i,
	.flatpickr-months .flatpickr-next-month i {
		position: relative;
	}

	.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
	.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
		left: 0;
	}

	.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
	.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
		right: 0;
	}


	.flatpickr-months .flatpickr-prev-month:hover,
	.flatpickr-months .flatpickr-next-month:hover {
		color: #f64747;
	}

	.flatpickr-months .flatpickr-prev-month:hover svg,
	.flatpickr-months .flatpickr-next-month:hover svg {
		fill: #f64747;
	}

	.flatpickr-months .flatpickr-prev-month svg,
	.flatpickr-months .flatpickr-next-month svg {
		width: 14px;
		height: 14px;
	}

	.flatpickr-months .flatpickr-prev-month svg path,
	.flatpickr-months .flatpickr-next-month svg path {
		transition: fill 0.1s;
		fill: inherit;
	}

	.numInputWrapper {
		position: relative;
		height: auto;
		border: 1px solid ${colorContrastLow};
		background: ${colorCanvas};
		width: 11ch;
	}

	.numInputWrapper input,
	.numInputWrapper span {
		display: inline-block;
	}

	.numInputWrapper input {
		width: 100%;
	}

	.numInputWrapper input::-ms-clear {
		display: none;
	}

	.numInputWrapper input::-webkit-outer-spin-button,
	.numInputWrapper input::-webkit-inner-spin-button {
		margin: 0;
		-webkit-appearance: none;
	}

	.numInputWrapper span {
		position: absolute;
		right: 0;
		width: 14px;
		padding: 0 4px 0 2px;
		height: 50%;
		line-height: 50%;
		opacity: 0;
		cursor: pointer;
		border: 1px solid rgba(64, 72, 72, 0.15);
		box-sizing: border-box;
	}

	.numInputWrapper span:hover {
		background: rgba(0, 0, 0, 0.1);
	}

	.numInputWrapper span:active {
		background: rgba(0, 0, 0, 0.2);
	}

	.numInputWrapper span:after {
		display: block;
		content: "";
		position: absolute;
	}

	.numInputWrapper span.arrowUp {
		top: 0;
		border-bottom: 0;
	}

	.numInputWrapper span.arrowUp:after {
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-bottom: 4px solid rgba(64, 72, 72, 0.6);
		top: 26%;
	}

	.numInputWrapper span.arrowDown {
		top: 50%;
	}

	.numInputWrapper span.arrowDown:after {
		border-left: 4px solid transparent;
		border-right: 4px solid transparent;
		border-top: 4px solid rgba(64, 72, 72, 0.6);
		top: 40%;
	}

	.numInputWrapper span svg {
		width: inherit;
		height: auto;
	}

	.numInputWrapper span svg path {
		fill: rgba(60, 63, 64, 0.5);
	}

	.numInputWrapper:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.numInputWrapper:hover span {
		opacity: 1;
	}

	.flatpickr-current-month {
		font-size: 1rem;
		line-height: inherit;
		font-weight: 300;
		color: inherit;
		position: absolute;
		width: 100%;
		left: auto;
		padding: 2px;
		line-height: 1;
		display: flex;
		text-align: center;
		transform: translate3d(0px, 0px, 0px);
		justify-content: center;
	}

	.flatpickr-current-month span.cur-month {
		font-family: inherit;
		font-weight: 700;
		color: inherit;
		display: inline-block;
		margin-inline-start: 0.5ch;
		padding: 0;
	}

	.flatpickr-current-month span.cur-month:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.flatpickr-current-month .numInputWrapper {
		width: 11ch;
		display: inline-block;
	}

	.flatpickr-current-month .numInputWrapper span.arrowUp:after {
		border-bottom-color: #3c3f40;
	}

	.flatpickr-current-month .numInputWrapper span.arrowDown:after {
		border-top-color: #3c3f40;
	}

	.flatpickr-current-month input.cur-year {
		background: transparent;
		box-sizing: border-box;
		color: inherit;
		cursor: text;
		padding: 0 8px;
		margin: 0;
		display: inline-block;
		font-size: inherit;
		font-family: inherit;
		font-weight: bold;
		line-height: inherit;
		height: 100%;
		border: 0;
		border-radius: 0;
		vertical-align: initial;
		-moz-appearance: textfield;
		appearance: textfield;
		text-align: center;
	}

	.flatpickr-current-month input.cur-year:focus {
		outline: 0;
	}

	.flatpickr-current-month input.cur-year[disabled],
	.flatpickr-current-month input.cur-year[disabled]:hover {
		font-size: 100%;
		color: rgba(60, 63, 64, 0.5);
		background: transparent;
		pointer-events: none;
	}

	.flatpickr-current-month .flatpickr-monthDropdown-months {
		appearance: menulist;
		background: ${colorCanvas};
		border: 1px solid ${colorContrastLow};
		border-radius: 0;
		box-sizing: border-box;
		color: inherit;
		cursor: pointer;
		font-size: inherit;
		font-family: inherit;
		font-weight: bold;
		height: auto;
		line-height: inherit;
		margin: 0;
		outline: none;
		padding: 4px 24px;
		position: relative;
		vertical-align: initial;

		width: auto;
		text-align-last: center;
		-webkit-appearance: initial;
		-moz-appearance: initial;
	}

	.flatpickr-current-month .flatpickr-monthDropdown-months:focus,
	.flatpickr-current-month .flatpickr-monthDropdown-months:active {
		outline: none;
	}

	.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
		background: rgba(0, 0, 0, 0.05);
	}

	.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
		background: transparent;
		outline: none;
		padding: 0;
	}

	.flatpickr-weekdays {
		background: transparent;
		text-align: center;
		overflow: hidden;
		width: 100%;
		display: flex;
		align-items: center;
		height: 28px;
	}

	.flatpickr-weekdays .flatpickr-weekdaycontainer {
		display: flex;
		flex: 1;
	}

	span.flatpickr-weekday {
		cursor: default;
		font-size: 90%;
		background: transparent;
		color: rgba(0, 0, 0, 0.54);
		line-height: 1;
		margin: 0;
		text-align: center;
		display: block;
		flex: 1;
		font-weight: bolder;
	}

	.dayContainer,
	.flatpickr-weeks {
		padding: 1px 0 0 0;
	}

	.flatpickr-days {
		position: relative;
		overflow: hidden;
		display: flex;
		align-items: flex-start;
		width: 307.875px;
	}

	.flatpickr-days:focus {
		outline: 0;
	}

	.dayContainer {
		padding: 0;
		outline: 0;
		text-align: left;
		width: 307.875px;
		min-width: 307.875px;
		max-width: 307.875px;
		box-sizing: border-box;
		display: inline-block;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		transform: translate3d(0px, 0px, 0px);
		opacity: 1;
	}

	.dayContainer + .dayContainer {
		box-shadow: -1px 0 0 #eee;
	}

	.flatpickr-day {
		background: none;
		border: 1px solid transparent;
		border-radius: 150px;
		box-sizing: border-box;
		color: #404848;
		cursor: pointer;
		font-weight: 400;
		width: 14.2857143%;
		flex-basis: 14.2857143%;
		max-width: 39px;
		height: 39px;
		line-height: 39px;
		margin: 0;
		display: inline-block;
		position: relative;
		justify-content: center;
		text-align: center;

		&.selected {
			background: ${colorPrimary};
			border-color: ${colorPrimary};
			font-weight: bold;

			&:hover {
				color: ${colorCanvas};
				background: ${colorPrimary};
				border-color: ${colorPrimary};
				font-weight: bold;
			}
		}

		&:hover {
			background: ${colorCanvas};
			border-color: ${colorPrimary};
			color: ${colorPrimary};
		}

		&.nextMonthDay:hover {
			border-top-color: ${colorPrimary};
			color: ${colorPrimary};
		}
	}

	.flatpickr-day.inRange,
	.flatpickr-day.prevMonthDay.inRange,
	.flatpickr-day.nextMonthDay.inRange,
	.flatpickr-day.today.inRange,
	.flatpickr-day.prevMonthDay.today.inRange,
	.flatpickr-day.nextMonthDay.today.inRange,
	.flatpickr-day:hover,
	.flatpickr-day.prevMonthDay:hover,
	.flatpickr-day.nextMonthDay:hover,
	.flatpickr-day:focus,
	.flatpickr-day.prevMonthDay:focus,
	.flatpickr-day.nextMonthDay:focus {
		cursor: pointer;
		outline: 0;
		background: ${colorCanvas};
		border-color: ${colorPrimary};
	}

	.flatpickr-day.today {
		border-color: #f64747;
	}

	.flatpickr-day.today:hover,
	.flatpickr-day.today:focus {
		border-color: #f64747;
		background: #f64747;
		color: ${colorCanvas};
	}

	.flatpickr-day.selected,
	.flatpickr-day.startRange,
	.flatpickr-day.endRange,
	.flatpickr-day.selected.inRange,
	.flatpickr-day.startRange.inRange,
	.flatpickr-day.endRange.inRange,
	.flatpickr-day.selected:focus,
	.flatpickr-day.startRange:focus,
	.flatpickr-day.endRange:focus,
	.flatpickr-day.selected:hover,
	.flatpickr-day.startRange:hover,
	.flatpickr-day.endRange:hover,
	.flatpickr-day.selected.prevMonthDay,
	.flatpickr-day.startRange.prevMonthDay,
	.flatpickr-day.endRange.prevMonthDay,
	.flatpickr-day.selected.nextMonthDay,
	.flatpickr-day.startRange.nextMonthDay,
	.flatpickr-day.endRange.nextMonthDay {
		background: ${colorPrimary};
		box-shadow: none;
		color: ${colorCanvas};
		border-color: ${colorPrimary};
	}

	.flatpickr-day.selected.startRange,
	.flatpickr-day.startRange.startRange,
	.flatpickr-day.endRange.startRange {
		border-radius: 50px 0 0 50px;
	}

	.flatpickr-day.selected.endRange,
	.flatpickr-day.startRange.endRange,
	.flatpickr-day.endRange.endRange {
		border-radius: 0 50px 50px 0;
	}

	.flatpickr-day.selected.startRange + .endRange:not(:nth-of-type(7n + 1)),
	.flatpickr-day.startRange.startRange + .endRange:not(:nth-of-type(7n + 1)),
	.flatpickr-day.endRange.startRange + .endRange:not(:nth-of-type(7n + 1)) {
		box-shadow: -10px 0 0 ${colorPrimary};
	}

	.flatpickr-day.selected.startRange.endRange,
	.flatpickr-day.startRange.startRange.endRange,
	.flatpickr-day.endRange.startRange.endRange {
		border-radius: 50px;
	}

	.flatpickr-day.inRange {
		border-radius: 0;
		box-shadow: -5px 0 0 #e9e9e9, 5px 0 0 #e9e9e9;
	}

	.flatpickr-day.flatpickr-disabled,
	.flatpickr-day.flatpickr-disabled:hover,
	.flatpickr-day.prevMonthDay,
	.flatpickr-day.nextMonthDay,
	.flatpickr-day.notAllowed,
	.flatpickr-day.notAllowed.prevMonthDay,
	.flatpickr-day.notAllowed.nextMonthDay {
		color: rgba(64, 72, 72, 0.3);
		background: transparent;
		border-color: #e9e9e9;
		cursor: default;
	}

	.flatpickr-day.flatpickr-disabled,
	.flatpickr-day.flatpickr-disabled:hover {
		cursor: not-allowed;
		color: rgba(64, 72, 72, 0.1);
	}

	.flatpickr-day.week.selected {
		border-radius: 0;
		box-shadow: -5px 0 0 ${colorPrimary}, 5px 0 0 ${colorPrimary};
	}

	.flatpickr-day.hidden {
		visibility: hidden;
	}

	.rangeMode .flatpickr-day {
		margin-top: 1px;
	}

	.flatpickr-weekwrapper {
		float: left;
	}

	.flatpickr-weekwrapper .flatpickr-weeks {
		padding: 0 12px;
		box-shadow: 1px 0 0 #eee;
	}

	.flatpickr-weekwrapper .flatpickr-weekday {
		float: none;
		width: 100%;
		line-height: 28px;
	}

	.flatpickr-weekwrapper span.flatpickr-day,
	.flatpickr-weekwrapper span.flatpickr-day:hover {
		display: block;
		width: 100%;
		max-width: none;
		color: rgba(64, 72, 72, 0.3);
		background: transparent;
		cursor: default;
		border: none;
	}

	.flatpickr-innerContainer {
		display: flex;
		box-sizing: border-box;
		overflow: hidden;
	}

	.flatpickr-rContainer {
		display: inline-block;
		padding: 0;
		box-sizing: border-box;
	}

	.flatpickr-input[readonly] {
		cursor: pointer;
	}

	@-webkit-keyframes fpFadeInDown {
		from {
			opacity: 0;
			transform: translate3d(0, -20px, 0);
		}
		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}
	@keyframes fpFadeInDown {
		from {
			opacity: 0;
			transform: translate3d(0, -20px, 0);
		}
		to {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	.flatpickr-calendar {
		width: 307.875px;
	}

	.dayContainer {
		padding: 0;
		border-right: 0;
	}

	span.flatpickr-day,
	span.flatpickr-day.prevMonthDay,
	span.flatpickr-day.nextMonthDay {
		border-radius: 0 !important;
		border: 1px solid #e9e9e9;
		max-width: none;
		border-right-color: transparent;
	}

	span.flatpickr-day:nth-of-type(7n-6),
	span.flatpickr-day.prevMonthDay:nth-of-type(7n-6),
	span.flatpickr-day.nextMonthDay:nth-of-type(7n-6) {
		border-left: 0;
	}

	span.flatpickr-day:nth-of-type(n + 36),
	span.flatpickr-day.prevMonthDay:nth-of-type(n + 36),
	span.flatpickr-day.nextMonthDay:nth-of-type(n + 36) {
		border-bottom: 0;
	}

	span.flatpickr-day:nth-of-type(-n + 7),
	span.flatpickr-day.prevMonthDay:nth-of-type(-n + 7),
	span.flatpickr-day.nextMonthDay:nth-of-type(-n + 7) {
		margin-top: 0;
	}

	span.flatpickr-day.today:not(.selected),
	span.flatpickr-day.prevMonthDay.today:not(.selected),
	span.flatpickr-day.nextMonthDay.today:not(.selected) {
		border-color: #e9e9e9;
		border-right-color: transparent;
		border-top-color: transparent;
		border-bottom-color: #f64747;
	}

	span.flatpickr-day.today:not(.selected):hover,
	span.flatpickr-day.prevMonthDay.today:not(.selected):hover,
	span.flatpickr-day.nextMonthDay.today:not(.selected):hover {
		border: 1px solid #f64747;
	}

	span.flatpickr-day.startRange,
	span.flatpickr-day.prevMonthDay.startRange,
	span.flatpickr-day.nextMonthDay.startRange,
	span.flatpickr-day.endRange,
	span.flatpickr-day.prevMonthDay.endRange,
	span.flatpickr-day.nextMonthDay.endRange {
		border-color: ${colorPrimary};
	}

	span.flatpickr-day.today,
	span.flatpickr-day.prevMonthDay.today,
	span.flatpickr-day.nextMonthDay.today,
	span.flatpickr-day.selected,
	span.flatpickr-day.prevMonthDay.selected,
	span.flatpickr-day.nextMonthDay.selected {
		z-index: 2;
	}

	.rangeMode .flatpickr-day {
		margin-top: -1px;
	}

	.flatpickr-weekwrapper .flatpickr-weeks {
		box-shadow: none;
	}

	.flatpickr-weekwrapper span.flatpickr-day {
		border: 0;
		margin: -1px 0 0 -1px;
	}

	.hasWeeks .flatpickr-days {
		border-right: 0;
	}

	@media screen and (min-width: 0\\0) and (min-resolution: 72dpi) {
		span.flatpickr-day {
			display: block;
			flex: 1 0 auto;
		}
	}
`
